import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Interceptor che aggiunge header per disabilitare la cache HTTP
 */
export const noCacheInterceptor: HttpInterceptorFn = (req, next) => {
  // Clona la richiesta e aggiunge gli header no-cache
  const noCacheReq = req.clone({
    setHeaders: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    }
  });

  return next(noCacheReq);
};
